import { Container, Grid } from '@material-ui/core'
import React, { useRef } from 'react'
import { useHistory } from "react-router";
import { ButtonAddHLPure, DialogSystemGLPure, HeaderHLPure, PromotionalFooterPure, SimpleLoading } from '../../pures'
import './digital-vault.css'

const DigitalVaultView = (props) => {
    const {
        isLoading,
        showLoadingRequesting,
        toggleErrorRequesting,
        showCompletedRequesting,
        toggleLoadingRequesting,
        showErrorRequesting,
        toggleCompletedRequesting,
        messageError,
        t,
        tabs,
        currentPageNum,
        changePage,
    } = props;

    const history = useHistory();
    const tabRef = useRef();

    if (isLoading) return <SimpleLoading />

    let Tab = tabs.length ? tabs[currentPageNum].component : null;
    const binTabIndex = tabs.findIndex(t => t.route == 'bin')
    let title = tabs.length ? tabs[currentPageNum].header || t("digitalVaultView.header.digital.vault") : t("digitalVaultView.header.digital.vault");

    return (
        <>
            <div className={"standard-wrapper"}>
                <Container>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <HeaderHLPure title={title} />
                        </Grid>

                        <Grid item xs={12} className='digitalVaultView-menu-container'>
                            <div className='digitalVaultView-menu' role="tablist">
                                {
                                    tabs.map((tab, i) => {
                                        if (tab.hidden) return <></>
                                        return (
                                            <button
                                                key={tab.route}
                                                className='digitalVaultView-menuItem'
                                                role='tab'
                                                aria-selected={i == currentPageNum}
                                                onClick={() => {
                                                    if (tabRef.current && tabRef.current.clearData) {
                                                        tabRef.current.clearData();
                                                    };
                                                    changePage(i)
                                                }}
                                            >
                                                {tab.title}
                                            </button>
                                        )
                                    })
                                }
                            </div>

                            <div className='digitalVaultView-menu-buttons'>
                                <ButtonAddHLPure
                                    nameBtn={t("digitalVaultView.btn.new.document")}
                                    onClickBtn={() => {
                                        if (tabRef.current && tabRef.current.newDocument) {
                                            const data = tabRef.current.newDocument();
                                            let newParams = new URLSearchParams()
                                            if (data.companyId) newParams.append("companyId", data.companyId)
                                            if (data.categoryId) newParams.append("categoryId", data.categoryId)
                                            if (data.subcategoryPath) newParams.append("path", data.subcategoryPath)

                                            history.push({ pathname: `/digital-vault-upload`, search: newParams.toString() })
                                        } else {
                                            history.push('/digital-vault-upload');
                                        }
                                    }}
                                    iconAdd
                                />

                                <button
                                    className='digitalVaultView-binBtn'
                                    role='tab'
                                    aria-selected={currentPageNum == binTabIndex}
                                    onClick={() => {
                                        changePage(binTabIndex)
                                    }}
                                    aria-labelledby='Papelera de reciclaje'
                                >
                                    <img src="https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/boveda-digital/PaperBin.svg" aria-hidden={true} />
                                </button>
                            </div>
                        </Grid>

                        {
                            Tab &&
                            <Grid item xs={12} role="tabpanel" aria-expanded={true}>
                                <Tab tabRef={tabRef} {...props} />
                            </Grid>
                        }

                        <Grid item xs={12}>
                            <PromotionalFooterPure />
                        </Grid>
                    </Grid>
                </Container>
            </div>

            <DialogSystemGLPure
                showLoadingRequesting={showLoadingRequesting}
                toggleLoadingRequesting={toggleLoadingRequesting}

                showCompletedRequesting={showCompletedRequesting}
                toggleCompletedRequesting={toggleCompletedRequesting}

                showErrorRequesting={showErrorRequesting}
                toggleErrorRequesting={toggleErrorRequesting}
                messageError={messageError} />
        </>
    )
}

export default DigitalVaultView